<div class="polaris-banner" [attr.data-tone]="tone">
  <div class="polaris-banner__icon">
    <i class="icon icon-{{ icon }}"></i>
  </div>
  <div class="polaris-banner__content">
    <ng-content></ng-content>
  </div>
</div>
